if (!customElements.get('cart-variant-picker')) {
  class CartVariantPicker extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.selects = Array.from(this.querySelectorAll('select'));
      this.selects.forEach((select) => select.addEventListener('change', () => this.onChange()));
    }

    onChange() {
      const chosen = this.selects.map((select) => select.value);
      const match = this.variants.find(
        (variant) => variant.options.length === chosen.length && variant.options.every((value, i) => value === chosen[i])
      );

      if (!match || !match.available) {
        this.setAttribute('data-unavailable', '');
        return;
      }

      this.removeAttribute('data-unavailable');
      this.setAttribute('data-loading', '');

      const line = this.dataset.line;
      const quantity = parseInt(this.dataset.quantity, 10) || 1;
      const config = { method: 'POST', headers: { 'Content-Type': 'application/json' } };

      // ponytail: remove + add (Shopify has no swap-variant call); reloads instead of
      // re-rendering sections - switch to section rendering if the flash becomes an issue.
      fetch(`${routes.cart_change_url}.js`, { ...config, body: JSON.stringify({ line: line, quantity: 0 }) })
        .then(() =>
          fetch(`${routes.cart_add_url}.js`, { ...config, body: JSON.stringify({ id: match.id, quantity: quantity }) })
        )
        .then(() => window.location.reload())
        .catch(() => {
          this.removeAttribute('data-loading');
        });
    }
  }

  customElements.define('cart-variant-picker', CartVariantPicker);
}
